import React, {Component} from 'react';
import '../../styles/TopArea.css'

import TopBar from './TopBar'
import MainArea from './MainArea'

class TopArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideMenuVisible: true
    };
    this.onMenuClick = this.onMenuClick.bind(this)
  }

  onMenuClick() {
    this.setState({
      sideMenuVisible: !this.state.sideMenuVisible
    });
  }

  render() {
    return (
      <div>
        <TopBar
          sideMenuVisible={this.state.sideMenuVisible}
          onMenuClick={this.onMenuClick}
        />
        <MainArea sideMenuVisible={this.state.sideMenuVisible} />
      </div>
    )
  }
}

export default TopArea;




/** WEBPACK FOOTER **
 ** ./src/components/main/TopArea.js
 **/